import { AbsoluteCenter, Box, Stack, Text, Button, Flex } from "@chakra-ui/react";
import Threads from "../components/Threads";
import Footer from "../components/footer";

export default function Home() {
	return (
		<Box position="relative" width="100%" height="100vh" overflow="hidden">
			<Box position="absolute" inset={0} zIndex={0}>
				<Threads amplitude={1} distance={0.3} enableMouseInteraction={true} />
			</Box>
			{/* <Header /> */}
			<AbsoluteCenter width="100%" padding={4} zIndex={1}>
				<Stack gap={4}>
					<Stack gap={0}>
						<Text fontSize="xl" color="fg">
							We are a quantitative investment holding company,
						</Text>
						<Text fontSize="xl" color="fg.subtle">
							capturing alpha beyond traditional boundaries.
						</Text>
					</Stack>
					<Flex gap={4}>
						<a href="/dashboard">
							<Button variant="solid">Investors</Button>
						</a>
						<a href="mailto:hello@1024holdings.com">
							<Button variant="subtle">Contact</Button>
						</a>
					</Flex>
				</Stack>
			</AbsoluteCenter>
			<Footer />
		</Box>
	);
}
